/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

import imgUrl from "$$RES/img/logo.png";

modulum("ApplicationLauncherWidget", ["WidgetGroupBase", "WidgetFactory"], function (context, cls) {
  /**
   * @class ApplicationLauncherWidget
   * @memberOf classes
   * @extends classes.WidgetGroupBase
   */
  cls.ApplicationLauncherWidget = context.oo.Class(cls.WidgetGroupBase, function ($super) {
    return /** @lends classes.ApplicationLauncherWidget.prototype */ {
      __name: "ApplicationLauncherWidget",

      /**
       * @inheritDoc
       * @param opts
       */
      constructor: function (opts) {
        $super.constructor.call(this, opts);

        const logoElement = this._element.getElementsByClassName("logo")[0];
        try {
          logoElement.setAttribute("src", imgUrl);
        } catch (e) {
          logoElement.setAttribute("src", context.ThemeService.getResource("img/logo.png"));
        }
        logoElement.setAttribute("alt", "Genero Browser Client");

        // Display GBC version and build number
        const versionElement = this._element.getElementsByClassName("field_version")[0];
        versionElement.textContent = context.version;

        const buildElement = this._element.getElementsByClassName("field_build")[0];
        buildElement.textContent = context.build + (context.dirtyFlag || "");
      }
    };
  });
  cls.WidgetFactory.registerBuilder("ApplicationLauncher", cls.ApplicationLauncherWidget);
});
